import { GenericTypeEnum } from "../enums/commons.enum";

export enum GenderType {
	Unknown = 0,
	Uninformed,
	Male,
	Female,
	NonBinary,
	Others
}
export class GenderEnum extends GenericTypeEnum<GenderType> {
	static readonly Unknown = new GenderEnum(GenderType.Unknown, "DICTIONARY.UNKNOWN");
	static readonly Uninformed = new GenderEnum(GenderType.Uninformed, "DICTIONARY.UNINFORMED");
	static readonly Male = new GenderEnum(GenderType.Male, "DICTIONARY.MALE");
	static readonly Female = new GenderEnum(GenderType.Female, "DICTIONARY.FEMALE");
	static readonly NonBinary = new GenderEnum(GenderType.NonBinary, "DICTIONARY.NONBINARY");
	static readonly Others = new GenderEnum(GenderType.Others, "DICTIONARY.OTHES");
}

export enum LegalPersonType {
	NaturalPerson = 1,
	JuridicalPerson
}
export class LegalPersonEnum extends GenericTypeEnum<LegalPersonType> {
	static readonly NaturalPerson = new LegalPersonEnum(LegalPersonType.NaturalPerson, "DICTIONARY.NATURAL_PERSON");
	static readonly JuridicalPerson = new LegalPersonEnum(LegalPersonType.JuridicalPerson, "DICTIONARY.JURIDICAL_PERSON");
}

export enum MaritalStatusType {
	Unknown = 0,
	Uninformed,
	Single,
	Married,
	Separated,
	Divorced,
	Widowed,
	DomesticPartnership
}
export class MaritalStatusEnum extends GenericTypeEnum<MaritalStatusType> {
	static readonly Unknown = new MaritalStatusEnum(MaritalStatusType.Unknown, "DICTIONARY.UNKNOWN");
	static readonly Uninformed = new MaritalStatusEnum(MaritalStatusType.Uninformed, "DICTIONARY.UNINFORMED");
	static readonly Single = new MaritalStatusEnum(MaritalStatusType.Single, "DICTIONARY.SINGLE");
	static readonly Married = new MaritalStatusEnum(MaritalStatusType.Married, "DICTIONARY.MARRIED");
	static readonly Separated = new MaritalStatusEnum(MaritalStatusType.Separated, "DICTIONARY.SEPARATED");
	static readonly Divorced = new MaritalStatusEnum(MaritalStatusType.Divorced, "DICTIONARY.DIVORCED");
	static readonly Widowed = new MaritalStatusEnum(MaritalStatusType.Widowed, "DICTIONARY.WIDOWED");
	static readonly DomesticPartnership = new MaritalStatusEnum(MaritalStatusType.DomesticPartnership, "DICTIONARY.DOMESTIC_PARTNERSHIP");
}

export enum PersonType {
    Unknown = 0,
	User = 1 << 0,
	TechnicalRepresentative = 1 << 1,
	Technician = 1 << 2,
	Client = 1 << 3,
	Partner = 1 << 4,
	Manufacturer = 1 << 5,
	Employee = 1 << 6,
	Consultant = 1 << 7
}
export class PersonEnum extends GenericTypeEnum<PersonType> {
	static readonly Unkown = new PersonEnum(PersonType.Unknown, "DICTIONARY.UNKNOWN");
	static readonly User = new PersonEnum(PersonType.User, "DICTIONARY.USER");
	static readonly TechnicalRepresentative = new PersonEnum(PersonType.TechnicalRepresentative, "DICTIONARY.TECHNICAL_REPRESENTATIVE");
	static readonly Technician = new PersonEnum(PersonType.Technician, "DICTIONARY.TECHNICIAN");
	static readonly Client = new PersonEnum(PersonType.Client, "DICTIONARY.CLIENT");
	static readonly Partner = new PersonEnum(PersonType.Partner, "DICTIONARY.PARTNER");
	static readonly Manufacturer = new PersonEnum(PersonType.Manufacturer, "DICTIONARY.MANUFACTURER");
	static readonly Employee = new PersonEnum(PersonType.Employee, "DICTIONARY.EMPLOYEE");
	static readonly Consultant = new PersonEnum(PersonType.Consultant, "DICTIONARY.CONSULTANT");
}

export enum AddressType {
	Residential = 1,
	Commercial
}
export class AddressTypeEnum extends GenericTypeEnum<AddressType> {
	static readonly Residential = new AddressTypeEnum(AddressType.Residential, "Residencial");
	static readonly Commercial = new AddressTypeEnum(AddressType.Commercial, "Comercial");
}

export enum ContactType {
	Email = 0,
	Phone
}
export class ContactTypeEnum extends GenericTypeEnum<ContactType> {
	static readonly Email = new ContactTypeEnum(ContactType.Email, "Email");
	static readonly Phone = new ContactTypeEnum(ContactType.Phone, "Telefone");
}

export enum SubType {
    Unknown = 0,
    Uninformed,
    Commercial,
    Cellphone,
    Landline,
    Personal,
}
export class SubTypeEnum extends GenericTypeEnum<SubType> {
	static readonly Unknown = new SubTypeEnum(SubType.Unknown, "Desconhecido");
	static readonly Uninformed = new SubTypeEnum(SubType.Uninformed, "Não Informado");
	static readonly Commercial = new SubTypeEnum(SubType.Commercial, "Comercial");
	static readonly Cellphone = new SubTypeEnum(SubType.Cellphone, "Celular");
	static readonly Landline = new SubTypeEnum(SubType.Landline, "Fixo");
	static readonly Personal = new SubTypeEnum(SubType.Personal, "Pessoal");
}

export enum PersonSubType {
	Unknown = 0,
	Owned,
	Outsource 
}
export class PersonSubTypeEnum extends GenericTypeEnum<PersonSubType> {
	//static readonly Unknown = new PersonSubTypeEnum(PersonSubType.Unknown, "Desconhecido");
	static readonly Owned = new PersonSubTypeEnum(PersonSubType.Owned, "Próprio");
	static readonly Outsource = new PersonSubTypeEnum(PersonSubType.Outsource, "Terceiro");
}

export enum PersonSubStatus {
    None = 0,
    Accreditation = 1 << 0,
    Active = 1 << 1,
	Inactive = 1 << 2,
	InAbsentia = 1 << 3,
	Suspended = 1 << 4
}
export class PersonSubStatusEnum extends GenericTypeEnum<PersonSubStatus> {
	//static readonly None = new PersonSubStatusEnum(PersonSubStatus.None, "Desconhecido");
	static readonly Accreditation = new PersonSubStatusEnum(PersonSubStatus.Accreditation, "Em Credenciamento");
	static readonly Active = new PersonSubStatusEnum(PersonSubStatus.Active, "Ativo");
	static readonly Inactive = new PersonSubStatusEnum(PersonSubStatus.Inactive, "Inativo");
	static readonly InAbsentia = new PersonSubStatusEnum(PersonSubStatus.InAbsentia, "Em Distrato");
	static readonly Suspended = new PersonSubStatusEnum(PersonSubStatus.Suspended, "Suspenso");
}

export enum AccountType {
	Savings = 1,
	Cash,
}
export class AccountTypeEnum extends GenericTypeEnum<AccountType> {
	static readonly Savings = new AccountTypeEnum(AccountType.Savings, "Poupança");
	static readonly Cash = new AccountTypeEnum(AccountType.Cash, "Conta Corrente");
}

export enum WeekDayType {
	Sunday = 1,
	Monday,
	Tuesday,
	Wednesday,
	Thursday,
	Friday,
	Saturday
}

export class WeekDayEnum extends GenericTypeEnum<WeekDayType> {
	static readonly Sunday = new WeekDayEnum(WeekDayType.Sunday, "Domingo");
	static readonly Monday = new WeekDayEnum(WeekDayType.Monday, "Segunda");
	static readonly Tuesday = new WeekDayEnum(WeekDayType.Tuesday, "Terça");
	static readonly Wednesday = new WeekDayEnum(WeekDayType.Wednesday, "Quarta");
	static readonly Thursday = new WeekDayEnum(WeekDayType.Thursday, "Quinta");
	static readonly Friday = new WeekDayEnum(WeekDayType.Friday, "Sexta");
	static readonly Saturday = new WeekDayEnum(WeekDayType.Saturday, "Sabado");
}